import Image from 'components/Common/Image/Image'

const SIZE_MAP = {
  width: 348,
  aspectRatio: '2:1',
}

function HelloFreshLogo() {
  return (
    <Image
      image={{ id: 'hello-fresh-logo' }}
      width={SIZE_MAP.width}
      aspectRatio={SIZE_MAP.aspectRatio}
      gravity="center"
      alt="Hello Fresh Logo"
    />
  )
}

export default HelloFreshLogo
